import { ShieldCheck } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";

const SCOPES = [
  "Luxury Residences",
  "Apartments & 3-BHKs",
  "Affordable Homes",
  "Corporate & Commercial",
  "Hospitality",
  "Full-House Renovation",
  "Furniture & Paint Refresh",
];

const STATS = [
  { v: "2018", l: "The Studio31 Founded" },
  { v: "19+", l: "Years of Design Practice" },
  { v: "55+", l: "Projects Delivered Across India" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-studio31-section" className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <Eyebrow>The Studio</Eyebrow>
          <h2 data-testid="about-heading" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink mt-5 leading-[1.05] max-w-3xl">
            A full-service design practice, built on warmth &amp; rigour
          </h2>
        </FadeUp>

        <div className="grid lg:grid-cols-12 gap-4 mt-16">
          <FadeUp className="lg:col-span-7" delay={0.05}>
            <div className="group relative overflow-hidden h-72 lg:h-full min-h-[320px]">
              <img
                src="/images/project-overview.jpg"
                alt="Knights Court dining suite designed by The Studio31"
                className="absolute inset-0 w-full h-full object-cover img-editorial transition-transform duration-[1.2s] ease-out group-hover:scale-105"
                loading="lazy"
              />
              <span className="absolute bottom-5 left-5 bg-cream/90 backdrop-blur px-4 py-2 font-display text-[10px] tracking-widest2 uppercase text-ink">
                Knights Court · Dining Suite
              </span>
            </div>
          </FadeUp>

          <div className="lg:col-span-5 flex flex-col gap-4">
            <FadeUp delay={0.12}>
              <div className="bg-ink text-cream p-8 lg:p-10 flex-1">
                <p className="font-serif text-2xl lg:text-[1.7rem] leading-snug">
                  Where functionality meets timeless design.
                </p>
                <p data-testid="about-description-text" className="mt-5 text-sm leading-relaxed text-cream/65">
                  The Studio31 is a full-service interior design &amp; architectural company in
                  Sector-150, Noida. Collaborating with architects, builders and homeowners, we
                  transform interiors into harmonious environments — from a quick refresh of
                  furniture and paint colours to an extensive full-house renovation, with the
                  expertise to make every project run smoothly.
                </p>
              </div>
            </FadeUp>

            <FadeUp delay={0.18}>
              <div data-testid="about-msme-card" className="bg-sand border border-hairline p-7 flex items-start gap-4 hover:border-brass/50 transition-colors duration-300">
                <ShieldCheck size={22} className="text-brass-deep shrink-0 mt-0.5" />
                <div>
                  <p className="font-display text-[11px] tracking-widest2 uppercase text-ink">MSME Certified · MICRO Unit</p>
                  <p className="text-xs text-taupe mt-2 leading-relaxed">
                    Registered under MSME — UDYAM-UP-28-0029913. A government-recognised design &amp;
                    architecture practice you can build with confidence.
                  </p>
                </div>
              </div>
            </FadeUp>

            <FadeUp delay={0.24}>
              <div className="border border-hairline bg-white p-7">
                <p className="font-display text-[10px] tracking-widest2 uppercase text-taupe mb-4">Where we work</p>
                <div className="flex flex-wrap gap-2">
                  {SCOPES.map((s) => (
                    <span key={s} className="text-[11px] tracking-wide border border-hairline text-espresso/75 px-3 py-1.5 hover:border-brass hover:text-ink transition-colors duration-200">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </FadeUp>
          </div>
        </div>

        <FadeUp delay={0.1}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 border-t border-hairline mt-16 pt-10">
            {STATS.map((s) => (
              <div key={s.l}>
                <div className="font-serif text-3xl lg:text-4xl text-ink">{s.v}</div>
                <div className="text-[11px] tracking-wider text-taupe uppercase mt-2">{s.l}</div>
              </div>
            ))}
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
